var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.766 4H4.23267C3.64441 4 3.16602 4.4784 3.16602 5.06666V11.4667C3.16602 12.0549 3.64441 12.5333 4.23267 12.5333H12.766C13.3542 12.5333 13.8327 12.0549 13.8327 11.4667V5.06666C13.8327 4.4784 13.3542 4 12.766 4ZM12.766 5.06666V5.3392L8.49934 8.65815L4.23267 5.33973V5.06666H12.766ZM4.23267 11.4667V6.69016L8.17187 9.75411C8.26526 9.82752 8.38058 9.86739 8.49934 9.86739C8.6181 9.86739 8.73342 9.82752 8.82681 9.75411L12.766 6.69016L12.7671 11.4667H4.23267Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.33b41a90325a262d6f1db951eefa3b7f.svg";
export { ForwardRef as ReactComponent };